// -- Resume with caution please --
var pin_count = 1;
var deliveryTrackerInnerLocked = false;
var deliveryTrackerLockCount = 0;
var refresh_timeout_id = 0;

function clear_list() {
    pin_count = 1;
    $('.aov-animation-pins').empty();
    $('.delivery_animation_goals').empty();
}

// Create a promise-based function to handle cart updates
function fetchCartData() {
    return new Promise((resolve, reject) => {
        jQuery.getJSON('/cart.js', function(cart) {
            resolve(cart);
        }).fail(function(error) {
            reject(error);
        });
    });
}

function updatePinsAndProgress(cart) {
    return new Promise((resolve) => {
      clear_list();
      aovb_limits.forEach(item => initLimit(item));
      spacePins();
      aovb_limits.forEach((item, index) => checkLimit(item, index, cart));
      aovb_limits.forEach(item => applyAutoAdd(item, cart));
      aovb_limits.forEach(item => removeAutoAdd(item, cart));
      aovb_limits.forEach(item => checkGoals(item, cart));
    });
}

// Utility function to create DOM element from an HTML string
function createElementFromHTML(htmlString) {
    var div = document.createElement('div');
    div.innerHTML = htmlString.trim();
    return div.firstElementChild;
}

// Function to initialize limits and pins
function initLimit(item) {
    createPIN(item);

    const elem = document.createElement('div');
    elem.classList.add('delivery_animation_goal_' + item.limit, 'delivery_animation_goal');

    if (item.type === 'product') {
        elem.appendChild(createElementFromHTML(item.image));
    } else if (item.type === 'shipping') {
        const iconElem = document.createElement('div');
        iconElem.classList.add('delivery_animation_icon');
        iconElem.textContent = '📦';
        elem.appendChild(iconElem);
    }

    const textElem = document.createElement('div');
    textElem.classList.add('delivery_animation_goal_text');
    textElem.textContent = item.list_text.replace('+$+', item.limit);
    elem.appendChild(textElem);

    $('.delivery_animation_goals').append(elem);
}

// Create pins based on limits
function createPIN(item) {
    let pin_percentage = (item.limit / aovb_limits.at(-2).limit) * 100;
    if (pin_percentage > 0 && pin_percentage <= 100 && $('.pin' + item.limit).length == 0) {
        let currencySymbol = '€';
        let pinTextClass = '';

        if (deliveryTracker_countrycode == 'CH') {
            currencySymbol = 'CHF';
            pinTextClass = 'pintext-CH';
        } else if (deliveryTracker_countrycode == 'DK') {
            currencySymbol = 'kr';
            pinTextClass = 'pintext-DK';
        }

        const image = item.image ? item.image : '<div class="packaging-emoji">📦</div>';
        const pin = `<div class='pin ${item.limit} pin${pin_count} pinFlex' style='left: ${pin_percentage}%;'>
          <div class='pin-flex-container'>
            <div class='pin-image'>${image}</div>
            <div class='pintext ${pinTextClass}'>${item.limit}<span style='font-size: 14px;'>${currencySymbol}</span></div>
          </div>
        </div>`;

        if (item.availability === true || item.availability === undefined) {
          $('.aov-animation-pins').append(pin);
        }
        pin_count++;
    }
}

// Space pins to avoid overlap
function checkSpace(item1, item2) {
    var distance = item2.position().left - item1.position().left - item1.children().width();
    if (distance < 10) {
        if (distance < -20) {
            item1.addClass('DT_nudge_large_left');
            item2.addClass('DT_nudge_large_right');
        } else {
            item1.addClass('DT_nudge_small_left');
            item2.addClass('DT_nudge_small_right');
        }
    }
}

// Ensure pins are spaced
function spacePins() {
  if ($('.pin').length >= 2) {
      for (let i = 1; i <= $('.pin').length - 1; i++) {
          const currentPin = $('.pin' + i);
          const nextPin = $('.pin' + (i + 1));

          if (currentPin.length && nextPin.length) {
              const currentLeft = parseFloat(currentPin.attr('style').split('left: ')[1]);
              const nextLeft = parseFloat(nextPin.attr('style').split('left: ')[1]);

              if ((nextLeft - currentLeft) < 10) {
                if (deliveryTracker_countrycode === 'DE') {
                  if (window.innerWidth > 768) {
                  nextPin.attr('style', `left: ${nextLeft + 5}%;`);
                  } else {
                    currentPin.attr('style', `left: ${currentLeft - 10}%;`);
                    nextPin.attr('style', `left: ${nextLeft - 2.5}%;`);
                  }
                }
                  if (deliveryTracker_countrycode === 'CH' && $('.pin').length >= 3) {
                    nextPin.attr('style', `left: ${nextLeft + 10}%;`);
                      const pins = document.querySelectorAll('.pin');
                      let pin1 = pins[1];
                      let pin2 = pins[2];
                      pins[1].classList.add("space-right");
                      pins[2].classList.add("space-left");

                  }
              }
          }
      }
  }
}

// Check the limit for each item
function checkLimit(item, index, cart) {
    let upper_border = 0;
    let lower_border = 0;
    let current_cart_value = 0;

    if (cart.items.every((cartItem) => cartItem.properties?._autoadd === '1' || cartItem.gift_card)) {
        return;
    }

    // Update the current cart value by filtering out ignored items and auto-added items
    for (let cartItem of cart.items) {
        if (ignoreaov_products.includes(cartItem.product_id) || cartItem.properties?._autoadd === '1') {
            continue;
        }
        current_cart_value += cartItem.final_line_price;
    }
    current_cart_value = current_cart_value / 100;

    if (current_cart_value < item.limit && upper_border === 0) {
        upper_border = item.limit;
        if (index >= 1) {
            lower_border = aovb_limits[index - 1].limit;
        }
    }
}

function applyAutoAdd(item, cart) {
    let current_cart_value = 0;
    cart.items.forEach(cartItem => {
        if (!ignoreaov_products.includes(cartItem.product_id) && cartItem.properties?._autoadd !== '1') {
            current_cart_value += cartItem.final_line_price;
        }
    });
    current_cart_value = current_cart_value / 100;

    if (item.type === 'product' && current_cart_value >= item.limit) {
        if (!cart.items.some((cartItem) => cartItem.id === parseInt(item.variantId) && cartItem.properties?._autoadd === '1')) {
            if (item.addLocked) {
                console.debug(`${item} is locked`);
                return;
            }
            if (cart.items.every((cartItem) => cartItem.properties?._autoadd === '1' || cartItem.gift_card)) {
                console.debug(`${item}: Cart contains only a gift card, nothing to add`);
                return;
            }
            item.addLocked = true;
            console.debug('add item');
            deliveryTrackerLockCount += 1;
            $.ajax({
                url: '/cart/add.js',
                type: 'post',
                dataType: 'json',
                data: {
                    items: [{id: item.variantId, properties: {_autoadd: 1}}],
                },
                success: function () {
                    document.documentElement.dispatchEvent(
                        new CustomEvent('cart:refresh', {
                            bubbles: true,
                        })
                    );
                    item.addLocked = false;
                    deliveryTrackerLockCount -= 1;
                },
            });
        }
    }
}

function removeAutoAdd(item, cart) {
    if (item.variantId <= 0 || item.type !== 'product') {
        return;
    }

    let current_cart_value = 0;
    cart.items.forEach(cartItem => {
        if (!ignoreaov_products.includes(cartItem.product_id) && cartItem.properties?._autoadd !== '1') {
            current_cart_value += cartItem.final_line_price;
        }
    });
    current_cart_value = current_cart_value / 100;

    // Remove any auto-added items that are not part of the limits
    for (var cartItem of cart.items) {
        if (cartItem.properties?._autoadd === '1' && !aovb_limits.some((limit) => limit.variantId === cartItem.id)) {
            console.warn('autoadd item not in limits', cartItem);
            removeCartItem(cartItem);
        }
    }

    let filteredItems = cart.items.filter((cartItem) => cartItem.id === parseInt(item.variantId) && cartItem.properties?._autoadd === '1');
    if (filteredItems.length > 1) {
        console.warn('multiple autoadd items found', filteredItems);
        let cart_item = filteredItems[1];
        removeCartItem(cart_item);
    }

    let cart_item = filteredItems[0];
    if (!cart_item) {
        return;
    }

    if (current_cart_value < item.limit || cart.items.every((cartItem) => cartItem.properties?._autoadd === '1' || cartItem.gift_card)) {
        console.debug('remove item', cart_item);
        removeCartItem(cart_item);
    }

    function removeCartItem(cart_item) {
        console.debug('remove item', cart_item);
        deliveryTrackerLockCount += 1;
        $.ajax({
            url: '/cart/change.js',
            type: 'post',
            dataType: 'json',
            data: {id: cart_item.key, quantity: cart_item.quantity - 1},
            success: function () {
                clearTimeout(refresh_timeout_id);
                refresh_timeout_id = setTimeout(function () {
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
                }, 200);
                deliveryTrackerLockCount -= 1;
            },
        });
    }
}

// Update the progress bar based on the current cart value and the applicable limit
function updateProgressBar(cart) {
    let current_cart_value = 0;

    cart.items.forEach(cartItem => {
        if (!ignoreaov_products.includes(cartItem.product_id) && cartItem.properties?._autoadd !== '1') {
            current_cart_value += cartItem.final_line_price;
        }
    });
    current_cart_value = current_cart_value / 100;

    let applicableLimit = aovb_limits.at(-2).limit;

    let percentage = (current_cart_value / applicableLimit) * 100;
    if (percentage > 100) {
        percentage = 100; // Cap the percentage at 100%
    }

    // Log for debugging - please dont remove
    /* console.log("Current cart value:", current_cart_value);
    console.log("Applicable limit:", applicableLimit.limit);
    console.log("Percentage for progress bar:", percentage + '%'); */

    if (!cart.items.every((cartItem) => cartItem.properties?._autoadd === '1' || cartItem.gift_card)) {
        $('.aov-animation-inner').css('width', percentage + '%');
        $('.aov-animation-inner-cart').css('width', percentage + '%');
    } else {
        $('.aov-animation-inner').css('width', '0%');
        $('.aov-animation-inner-cart').css('width', '0%');
    }
}

function checkGoals(item, cart) {
    let current_cart_value = 0;
    cart.items.forEach(cartItem => {
        if (!ignoreaov_products.includes(cartItem.product_id) && cartItem.properties?._autoadd !== '1') {
            current_cart_value += cartItem.final_line_price;
        }
    });
    current_cart_value = current_cart_value / 100;

    if (cart.items.every((cartItem) => cartItem.properties?._autoadd === '1' || cartItem.gift_card)) {
        return;
    }

    if (item.type === 'product' || item.type === 'shipping') {
        if (current_cart_value < item.limit) {
            if ($('.delivery_animation_goal_' + item.limit).hasClass('active')) {
                $('.delivery_animation_goal_' + item.limit).removeClass('active');
                $('.delivery_animation_goal_' + item.limit + ' .delivery_animation_goal_text').hide(400, function () {
                    $('.delivery_animation_goal_' + item.limit + ' .delivery_animation_goal_text')
                        .text(item.list_text.replace('+$+', item.limit))
                        .show(400);
                });
                $('.aov-animation-wrapper .aov-animation-pins .pin.' + item.limit).removeClass('active');
            }
        } else {
            if (!$('.delivery_animation_goal_' + item.limit).hasClass('active')) {
                $('.delivery_animation_goal_' + item.limit).addClass('active');
                $('.delivery_animation_goal_' + item.limit + ' .delivery_animation_goal_text').hide(400, function () {
                    $('.delivery_animation_goal_' + item.limit + ' .delivery_animation_goal_text')
                        .text(item.list_reached_text.replace('+$+', item.limit))
                        .show(400);
                });
                $('.aov-animation-wrapper .aov-animation-pins .pin.' + item.limit).addClass('active');
            }
        }
    }

    let pos = $('.pin.active').last().position();
    if (pos && $('.pin.active')) {
        $('.aov-animation-inner-achieved').css('width', pos.left + 9 + 'px');
        $('.aov-animation-inner-achieved-cart').css('width', pos.left + 1 + 'px');
        if (deliveryTracker_countrycode === 'CH') {
            $('.aov-animation-inner-achieved').css('width', pos.left + 10 + 'px');
            $('.aov-animation-inner-achieved-cart').css('width', pos.left + 12 + 'px');
        }
    } else {
        $('.aov-animation-inner-achieved').css('width', '0px');
        $('.aov-animation-inner-achieved-cart').css('width', '0px');
    }

}

function updateProgressText(cart) {
  let current_cart_value = 0;
  cart.items.forEach(cartItem => {
      if (!ignoreaov_products.includes(cartItem.product_id) && cartItem.properties?._autoadd !== '1') {
          current_cart_value += cartItem.final_line_price;
      }
  });
  current_cart_value = current_cart_value / 100;

  let decimalCount = 2;
  if (deliveryTracker_countrycode === 'DK') {
      decimalCount = 0;
  }

  let nextLimit = aovb_limits.find(limit => current_cart_value < limit.limit) || aovb_limits[aovb_limits.length - 1];
  let amount_remaining = (nextLimit.limit - current_cart_value).toFixed(decimalCount);
  fetchCartData()
    .then(cart => {
      updateProgressBar(cart);
      updatePinsAndProgress(cart);
    })
    .catch(error => console.error("Error fetching cart:", error));
  let progressText;
  if (current_cart_value < nextLimit.limit) {
      progressText = nextLimit.progbar_text.replace('+$+', amount_remaining);
  } else {
      progressText = nextLimit.list_reached_text;
  }

  $('.deliveryTracker_shipping_text').text(progressText);

  if (!$('.aov-animation-header').hasClass('updated') || $('.aov-animation-header').text() !== progressText) {
      $('.aov-animation-header').fadeOut(500, function () {
          $('.aov-animation-header').text(progressText).fadeIn(500).addClass('updated');
      });
  }
}


// Event listeners
document.addEventListener('deliveryUpdate', function(event) {
    if (deliveryTrackerInnerLocked) {
        console.debug('delivery tracker inner locked');
        return;
    }

    deliveryTrackerInnerLocked = true;
    fetchCartData()
        .then(cart => {
            updatePinsAndProgress(cart);
            updateProgressBar(cart);
            updateProgressText(cart);
        })
        .finally(() => {
            deliveryTrackerInnerLocked = false;
        })
});
/* REVIEW: We don't actually need this right? */
document.dispatchEvent(new Event('deliveryUpdate', { bubbles: true }));
document.addEventListener('cart:refresh', function(event) {
  fetchCartData()
    .then(cart=> {
      updatePinsAndProgress(cart);
      updateProgressBar(cart);
      updateProgressText(cart);
    })
    .catch(error => console.error("Error fetching cart:", error));
});
// PROBLEM: IF the third limit is reached, inner achieved cart is calculated wrong -> NO
// PROBLEM: OVER 100% is possible -> NO
// PROBLEM: IF the third limit is reached, AND the total is over reached, the inner achieved cart should not be calculated correclty



// IfThisAddThapp END
// Add To Cart Button for Suggested Streuer
$('#add-to-cart').submit(function () {
  $.ajax({
    url: '/cart/add.js',
    type: 'post',
    dataType: 'json',
    data: $('#add-to-cart').serialize(),
    success: function (data) {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
        })
      )
    },
  })
  return false
})

// Notification close Logic

if (aovb_settings.bottom_bar_active && !document.cookie.includes('delivery_notification_closed')) {
  $('.deliveryTracker_shipping_notification').show()
  $('.deliveryTracker_shipping_x').click(function () {
    document.cookie = 'delivery_notification_closed=true'
    $('.deliveryTracker_shipping_notification').hide()
  })
}

if (TopNotification_active && !document.cookie.includes('top_notification_closed')) {
  $('.TopNotification').show()
  $('.TopNotification_x').click(function () {
    document.cookie = 'top_notification_closed=true'
    $('.TopNotification').hide()
  })
}

// InventoryCounter
if (InventoryCounter_deduct >= 0) {
  InventoryCounter_current = InventoryCounter_current - InventoryCounter_deduct
  InventoryCounter_total = InventoryCounter_total - InventoryCounter_deduct
}
var IC_percentage = (InventoryCounter_current / InventoryCounter_total) * 100
$('.InventoryCounter-CounterInner').css('width', 100 - IC_percentage + '%')
if (IC_percentage == 0) {
  $('.InventoryCounter-pins').hide()
  $('.InventoryCounter-Counter').hide()
  if (InventoryCounter_finished != '') {
    $('.InventoryCounter-Text').text(InventoryCounter_finished)
  } else {
    $('.ProductMeta__InventoryCounter').hide()
  }
  $('.InventoryCounter-Header').css('margin-bottom', '0')
} else {
  if (IC_percentage <= 100 && $('.pin.' + InventoryCounter_current).length == 0) {
    if (IC_percentage >= 10) $('.InventoryCounter-pins').append('<div class="pin" style="left: 0%;"><div class="pintext">0</div></div>')
    $('.InventoryCounter-pins').append(
      '<div class="pin ' +
        InventoryCounter_current +
        '" style="left: ' +
        IC_percentage +
        '%;"><div class="pintext">' +
        InventoryCounter_current +
        '</div></div>'
    )
    if (IC_percentage <= 90)
      $('.InventoryCounter-pins').append('<div class="pin" style="left: 100%;"><div class="pintext">' + InventoryCounter_total + '</div></div>')
  }
}

// Growganic Cart Upsell
// document.addEventListener('cartReplaced', function (event) {
//   jQuery.getJSON('/cart.js', function (cart) {
//     if (cart.items.length > 0) {
//       var product_id = cart.items[0].product_id
//       const productRecommendationsSection = document.querySelector('#Upsell-Wrapper')

//       fetch(window.Shopify.routes.root + `recommendations/products?product_id=${product_id}&limit=10&section_id=cart-upsell&intent=related`)
//         .then((response) => response.text())
//         .then((text) => {
//           const html = document.createElement('div')
//           html.innerHTML = text
//           const recommendations = html.querySelector('#shopify-section-cart-upsell')

//           if (recommendations && recommendations.innerHTML.trim().length) {
//             productRecommendationsSection.innerHTML = recommendations.innerHTML
//             productRecommendationsSection.querySelector('#upsell-atc').addEventListener('click', function (e) {
//               e.preventDefault()
//               const variantId = e.currentTarget.dataset.variant
//               document.dispatchEvent(new CustomEvent('theme:loading:start'))
//               let formData = {
//                 items: [
//                   {
//                     id: variantId,
//                     quantity: 1,
//                   },
//                 ],
//               }

//               fetch(window.Shopify.routes.root + 'cart/add.js', {
//                 body: JSON.stringify(formData),
//                 credentials: 'same-origin',
//                 method: 'POST',
//                 headers: {
//                   'Content-Type': 'application/json',
//                   'X-Requested-With': 'XMLHttpRequest', // This is needed as currently there is a bug in Shopify that assumes this header
//                 },
//               }).then(function (response) {
//                 document.dispatchEvent(new CustomEvent('theme:loading:end'))
//                 document.dispatchEvent(
//                   new CustomEvent('product:added', {
//                     bubbles: true,
//                     detail: {
//                       variant: variantId,
//                       quantity: 1,
//                     },
//                   })
//                 )
//               })
//             })
//           }
//         })
//     }
//   })
// })

class MobileDrawerUpsell extends HTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      observer.unobserve(this)
      this.fetchUpsellContent(this.dataset.url)
    }
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px',
    }).observe(this)
  }

  async fetchUpsellContent(url) {
    if (!(await this.isCartEmpty())) {
      try {
        const response = await fetch(url)
        if (response.ok) {
          const text = await response.text()
          const html = document.createElement('div')
          html.innerHTML = text
          const recommendations = html.querySelector('mobile-drawer-upsell')
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML
          }
          if (html.querySelector('.grd-single-slide')) {
            this.classList.add('drawer-upsell--loaded')
          }
        }
      } catch (e) {}
    }
  }

  async isCartEmpty() {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`)
      if (response.ok) {
        const cart = await response.json()
        return cart.item_count === 0
      }
    } catch (e) {
      return true
    }
    return true
  }
}

customElements.define('mobile-drawer-upsell', MobileDrawerUpsell)

class DrawerUpsell extends HTMLElement {
  constructor() {
    super()
  }
  connectedCallback() {
    this.fetchUpsellContent(this.dataset.url)
  }

  async fetchUpsellContent(url) {
    if (!(await this.isCartEmpty())) {
      try {
        const response = await fetch(url)
        if (response.ok) {
          const text = await response.text()
          const html = document.createElement('div')
          html.innerHTML = text
          const recommendations = html.querySelector('drawer-upsell')
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML
          }
          if (html.querySelector('.grid__item')) {
            this.classList.add('drawer-upsell--loaded')
          }
        }
      } catch (e) {}
    }
  }

  async isCartEmpty() {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`)
      if (response.ok) {
        const cart = await response.json()
        return cart.item_count === 0
      }
    } catch (e) {
      return true
    }
    return true
  }
}

customElements.define('drawer-upsell', DrawerUpsell)

if (!customElements.get('product-upsell')) {
  customElements.define(
    'product-upsell',
    class ProductUpsell extends HTMLElement {
      constructor() {
        super()
        this.loadUpsell()
      }

      async loadUpsell() {
        if (!(await this.isCartEmpty())) {
          const url = `${window.Shopify.routes.root}recommendations/products?product_id=${this.dataset.productId}&limit=1&section_id=product-upsell`
          try {
            const response = await fetch(url)
            if (response.ok) {
              const text = await response.text()
              this.innerHTML = text
              const productUpsellWrapper = this.querySelector('.ProductUpsell--Wrapper button')
              if (productUpsellWrapper) {
                productUpsellWrapper.addEventListener('click', this.handleUpsellClick.bind(this))
              }
            }
          } catch (e) {}
        }
      }

      async handleUpsellClick(e) {
        const productUpsellWrapper = e.target.closest('.ProductUpsell--Wrapper button')
        if (!productUpsellWrapper) return

        const variantId = productUpsellWrapper.dataset.variantId
        document.dispatchEvent(new CustomEvent('theme:loading:start'))

        const formData = {
          items: [
            {
              id: variantId,
              quantity: 1,
            },
          ],
        }

        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest', // This is needed as currently there is a bug in Shopify that assumes this header
            },
            body: JSON.stringify(formData),
          })

          if (response.ok) {
            document.dispatchEvent(new CustomEvent('theme:loading:end'))
            document.dispatchEvent(
              new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                  variant: variantId,
                  quantity: 1,
                },
              })
            )
          } else {
            document.dispatchEvent(new CustomEvent('theme:loading:end'))
          }
        } catch (error) {
          document.dispatchEvent(new CustomEvent('theme:loading:end'))
        }
      }

      getProduct() {
        const isUpsellActive = this.querySelector('input')?.checked
        const variantId = this.querySelector('.ProductUpsell--Wrapper')?.dataset.variantId
        return isUpsellActive && variantId ? variantId : null
      }

      async isCartEmpty() {
        try {
          const response = await fetch(`${window.Shopify.routes.root}cart.js`)
          if (response.ok) {
            const cart = await response.json()
            return cart.item_count === 0
          }
        } catch (e) {
          return true
        }
        return true
      }
    }
  )
}
